import { Locale } from '@synergy/models';
import { createAction } from '@reduxjs/toolkit';

export const changeSelectedLanguage = createAction<Locale>('common/changeSelectedLanguage');
export const resetSelectedLanguage = createAction<void>('common/resetSelectedLanguage');
